import {
  FETCH_DELETION_REQUESTS,
  FETCH_DELETION_REQUESTS_SUCCESS,
  FETCH_DELETION_REQUESTS_FAILED,
  REQUEST_ACCOUNT_DELETION,
  REQUEST_ACCOUNT_DELETION_SUCCESS,
  REQUEST_ACCOUNT_DELETION_FAILED,
  FETCH_MY_DELETION_REQUEST,
  EDIT_DELETION_REQUEST
} from "../store/types";

export const INITIAL_STATE = {
  requests: null,
  myRequest: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const deletionrequestreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DELETION_REQUESTS:
    case REQUEST_ACCOUNT_DELETION:
      return {
        ...state,
        loading: true
      };
    case FETCH_DELETION_REQUESTS_SUCCESS:
      return {
        ...state,
        requests: action.payload,
        loading: false,
        error: { flag: false, msg: null }
      };
    case FETCH_DELETION_REQUESTS_FAILED:
      return {
        ...state,
        requests: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case REQUEST_ACCOUNT_DELETION_SUCCESS:
      return {
        ...state,
        myRequest: action.payload,
        loading: false,
        error: { flag: false, msg: null }
      };
    case REQUEST_ACCOUNT_DELETION_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case FETCH_MY_DELETION_REQUEST:
      return {
        ...state,
        myRequest: action.payload,
        loading: false
      };
    case EDIT_DELETION_REQUEST:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};
